module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022-1536x1014.77034209.jpg";